import store from "../store";


export const proposalSelectors = {
	content: (state = store.getState()) => state.proposal.content,
	proposal: (state = store.getState()) => state.proposal.content.proposal,
	proposalId: (state = store.getState()) => state.proposal.content.proposal.proposalId,
	proposalIsFetching: (state = store.getState()) => state.proposal.content.proposal.isFetching,
	proposalIsRefresh: (state = store.getState()) => state.proposal.content.proposal.isRefresh,
	proposalError: (state = store.getState()) => state.proposal.content.proposal.error,
	values: (state = store.getState()) => state.proposal.content.values,
	valuesIsFetching: (state = store.getState()) => state.proposal.content.values.isFetching,
	valuesIsRefresh: (state = store.getState()) => state.proposal.content.values.isRefresh,
	valuesError: (state = store.getState()) => state.proposal.content.values.error,
	caseInstanceId: (state = store.getState()) => state.proposal.content.proposal.caseInstanceId,
	id: (state = store.getState()) => state.proposal.content.proposal.proposalId,
};
